import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import http from "../services/http";
import Bin from "../components/common/Bin";
import Select from "../components/common/select";
import TextArea from "../components/common/textArea";
import UserContext from "../context/userContext";

const Twitter = () => {
  const [user] = useContext(UserContext);

  const [type, setType] = useState("Operations");
  const [comments, setComments] = useState("");
  const [logged, setLogged] = useState([]);

  const types = [
    { id: "Operations", name: "Operations" },
    { id: "Customer Supply", name: "Customer Supply" },
  ];

  useEffect(() => {
    async function getLogged() {
      try {
        const { data } = await http.get(`/comments/${moment().format("YYYY-MM-DD")}`);
        setLogged(data);
      }
      catch {
        //ignore error
      }
    }
    
    getLogged();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    // Validate
    const data = { type: type, comments: comments };
    try {
      const { data: comment } = await http.post(`/comments`, data);
      setLogged([...logged, comment]);
      toast.success("Comment Submitted");
    } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  async function handleDelete(comment) {
    const oldLogged = [...logged];
    setLogged(logged.filter((c) => c.ID !== comment.ID));
    try {
      await http.delete(`/comments/${comment.ID}`);
      toast.success("Comment Removed");
    } catch (ex) {
      setLogged(oldLogged);
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }
  return (
    <div className="col mt-4">
      <form className="container">
        <div className="row">
          <div className="col">
            <h3>
              {user && user.FULL_NAME} - {user && user.LONG_SITE}
            </h3>
            <h4 className="text-muted">
              {moment().format("dddd Do MMMM HH:mm")}
            </h4>
            <h5 className="text-muted">
              {moment().isAfter(moment().hour(10).minute(20))
                ? "Late Comment"
                : "On Time"}
            </h5>
          </div>
        </div>
        {/* <div className="row">{moment(date).format("DD-MMM-YY HH:mm")}</div> */}
        <div className="row">
          <div className="col-auto">
            <Select
              name="types"
              label="Type"
              placeholder="Select Type"
              value={type}
              options={types}
              onChange={(e) => setType(e.currentTarget.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <TextArea
              name="comments"
              label="Comments"
              value={comments}
              onChange={(e) => setComments(e.currentTarget.value)}
              rows="10"
            />
          </div>
        </div>
        <div className="row">
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </form>
      {logged.map((comment, i) => (
        <div key={i} className="row my-3">
          <div className="col">
            <div className="card mx-3 my-1">
              <div className="card-header">
                <h5 className="card-title">
                  {comment.NAME} - {comment.TYPE}
                </h5>
                <h6 className="card-subtitle text-muted">
                  {comment.SITE} -{" "}
                  {moment(comment.RECORD_DATE).utc().calendar()}
                </h6>
              </div>
              <div className="card-body">
                {comment.MESSAGE.split(/\n/g).map((m, i) => (
                  <p key={i} className="card-text">
                    {m}
                  </p>
                ))}
                {user.USERNAME === comment.USERNAME && (
                  <div className="d-flex position-relative justify-content-end">
                    <Bin onClick={() => handleDelete(comment)} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Twitter;
